/**
 * Get translated string for use in JavaScript code.
 *
 * Usage:
 *   const intl = useIntl()
 *   const msg = label(intl, 'error_unexpected')
 *   Notify.error(msg)
 */
const label = (intl, key, params) => {
  return intl.formatMessage({ id: key }, params)
}

export default label
